import { ArrowRightIcon, PhoneIcon } from '@heroicons/react/outline';
import React from 'react';

export default function Navbar() {
    return (
        <div>
            <div className='max-w-7xl p-5 mx-auto flex justify-center md:justify-between'>
                <a href="/">
                    <div className='flex items-center justify-center font-serif text-2xl text-white'>
                        <img src="/unitedtaxattorneys.png" alt="United Tax Attorneys" className='h-14' />
                    </div>
                </a>
                <div className='flex items-center justify-end gap-6'>
                    <a href="tel:8884092328" className="hidden md:flex items-center justify-center text-base hover:underline text-gray-900 font-semibold">
                        <PhoneIcon className='mr-2 h-4 w-4' /> (888) 409-2328
                    </a>
                    <a href="/#start" className="hidden md:flex bg-red-700 hover:bg-red-900 text-white w-full md:w-fit text-center px-6 h-12 items-center justify-center text-xl rounded-full font-semibold">
                        Get Started Today <ArrowRightIcon className='ml-2 h-4 w-4' />
                    </a>
                </div>
            </div>
        </div>
    );
}
